const KEY = 'dispute_letter_style';
const DEFAULT = { hwStyle: 'playpen_sans', signatureFont: 'cursive_elegant' };

export const getLetterStyle = () => {
  try { return { ...DEFAULT, ...JSON.parse(localStorage.getItem(KEY) || '{}') }; } catch (_e) { return DEFAULT; }
};
export const saveLetterStyle = (style) => localStorage.setItem(KEY, JSON.stringify({ ...getLetterStyle(), ...style }));
